import axios from 'axios';

const setAuthToken = (token) => {
  axios.defaults.headers.common[
    'x-yumyum-key'
  ] = `${process.env.REACT_APP_X_YUMYUM_KEY}`;
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete axios?.defaults?.headers?.common['Authorization'];
  }
};

export default setAuthToken;
